import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from '../utils/format.utils';

/**
 * Formats a stored phone number for display.
 *
 * Usage:
 *   {{ customer.phone | phoneFormat }}   → "(555) 123-4567"
 *
 * Phone inputs are masked with ngx-mask, which stores the digits only
 * ("5551234567"), so values must be formatted on the way out. Anything that
 * isn't 10 or 11 digits passes through untouched, which keeps legacy rows
 * saved before masking existed readable.
 */
@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return formatPhoneNumber(value);
  }
}
